/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Api_Models_ElectronicClocks_DisplayBrightnessModel } from '../models/BigClock_Api_Models_ElectronicClocks_DisplayBrightnessModel';
import type { BigClock_Api_Models_ElectronicClocks_MeteoModel } from '../models/BigClock_Api_Models_ElectronicClocks_MeteoModel';
import type { BigClock_Api_Models_ElectronicClocks_ScreenDelayModel } from '../models/BigClock_Api_Models_ElectronicClocks_ScreenDelayModel';
import type { BigClock_Api_Models_SetDeviceSourceModel } from '../models/BigClock_Api_Models_SetDeviceSourceModel';
import type { BigClock_Api_Models_StateModel } from '../models/BigClock_Api_Models_StateModel';
import type { BigClock_Application_Queries_GetElectronicClockWorkdays_GetElectronicClockWorkdaysResponse } from '../models/BigClock_Application_Queries_GetElectronicClockWorkdays_GetElectronicClockWorkdaysResponse';
import type { BigClock_Application_Queries_ReadElectronicClocksParams_ReadElectronicClocksParamsResponse } from '../models/BigClock_Application_Queries_ReadElectronicClocksParams_ReadElectronicClocksParamsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ElectronicClockService {
    /**
     * @param electronicClockId
     * @returns BigClock_Application_Queries_ReadElectronicClocksParams_ReadElectronicClocksParamsResponse Success
     * @throws ApiError
     */
    public static getApiElectronicClockParams(
        electronicClockId: string,
    ): CancelablePromise<BigClock_Application_Queries_ReadElectronicClocksParams_ReadElectronicClocksParamsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ElectronicClock/{electronicClockId}/params',
            path: {
                'electronicClockId': electronicClockId,
            },
        });
    }
    /**
     * @param electronicClockId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiElectronicClockDisplayState(
        electronicClockId: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ElectronicClock/{electronicClockId}/display/state',
            path: {
                'electronicClockId': electronicClockId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param electronicClockId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiElectronicClockDisplayBrightness(
        electronicClockId: string,
        requestBody?: BigClock_Api_Models_ElectronicClocks_DisplayBrightnessModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ElectronicClock/{electronicClockId}/display/brightness',
            path: {
                'electronicClockId': electronicClockId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param electronicClockId
     * @returns BigClock_Application_Queries_GetElectronicClockWorkdays_GetElectronicClockWorkdaysResponse Success
     * @throws ApiError
     */
    public static getApiElectronicClockWorkdays(
        electronicClockId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetElectronicClockWorkdays_GetElectronicClockWorkdaysResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ElectronicClock/{electronicClockId}/workdays',
            path: {
                'electronicClockId': electronicClockId,
            },
        });
    }
    /**
     * @param electronicClockId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiElectronicClockScreenDelay(
        electronicClockId: string,
        requestBody?: BigClock_Api_Models_ElectronicClocks_ScreenDelayModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ElectronicClock/{electronicClockId}/screen-delay',
            path: {
                'electronicClockId': electronicClockId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param electronicClockId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiElectronicClockSerialState(
        electronicClockId: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ElectronicClock/{electronicClockId}/serial/state',
            path: {
                'electronicClockId': electronicClockId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param electronicClockId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiElectronicClockMeteo(
        electronicClockId: string,
        requestBody?: BigClock_Api_Models_ElectronicClocks_MeteoModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ElectronicClock/{electronicClockId}/meteo',
            path: {
                'electronicClockId': electronicClockId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param electronicClockId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiElectronicClockMeteoSource(
        electronicClockId: string,
        requestBody?: BigClock_Api_Models_SetDeviceSourceModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ElectronicClock/{electronicClockId}/meteo-source',
            path: {
                'electronicClockId': electronicClockId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
